<template>
    <div>
        <rkm-modal
            :buttons="['cancel']"
            extraLarge
            ref="RkmModal"
            title="Detalhamento do agendamento"
        >
            <rkm-alert show info v-if="item">
                <rkm-row>
                    <rkm-col cols="6"><strong>Agendamento: </strong>{{ item.agendamentoNumero }}</rkm-col>
                    <rkm-col cols="6"><strong>Médico solicitante: </strong>{{ item.medicoNome }}</rkm-col>
                    <rkm-col cols="6"><strong>Unidade solicitante: </strong>{{ item.unidadeNome }}</rkm-col>
                    <rkm-col cols="6"><strong>Local de atendimento: </strong>{{ item.localAtendimento }}</rkm-col>

                </rkm-row>
            </rkm-alert>

            <template>
                <rkm-area
                    title="Exames solicitados"
                    no-margin-top
                    class="pb-0 mb-0"
                >

                    <rkm-table
                        :items="items"
                        :fields="fields"
                    />
                </rkm-area>

                <rkm-area
                    v-if="item && item.medicamentos"
                    title="Uso de medicamentos"
                    type="fieldset"
                >

                    <template>
                        {{ item.medicamentos }}
                    </template>
                </rkm-area>

                <rkm-area
                    v-if="item && item.suspeita"
                    title="Suspeita clínica"
                    type="fieldset"
                >

                    <template>
                        {{ item.suspeita  }}
                    </template>
                </rkm-area>

                <rkm-area
                    v-if="item && item.observacao"
                    title="Observação"
                    type="fieldset"
                >

                    <template>
                        {{ item.observacao  }}
                    </template>
                </rkm-area>
            </template>
        </rkm-modal>
    </div>
</template>

<script>

// Mixins.
import { error } from '@/mixins'

export default {
    computed: {
        fields() {
            const fields = [
                {
                    key: "nome",
                    label: "Exame",
                    class: 'col-6',
                    sortable: true
                },
                {
                    key: "status",
                    label: "Status",
                    class: 'col-6',
                    sortable: true
                },
            ]

            return fields
        },
    },
    data: () => ({
        dia: null,
        semanaId: null,
        items: null,
        item: null
    }),
    methods: {
        open(item) {

            this.item = item
            this.items = item.incluido

            this.$refs.RkmModal.show()
        },
    },
    mixins: [ error ],
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
</style>